import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-16-attention.tsx
/**
* icon.16.attention
*
* Attention, warning, exclamation mark
*
* Keywords: exclamation, alert, warning, circle, notification, error, caution, urgent
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTggMmE2IDYgMCAxIDEgMCAxMkE2IDYgMCAwIDEgOCAybTAgMWE1IDUgMCAxIDAgMCAxMEE1IDUgMCAwIDAgOCAzbTAgNi41YS43NS43NSAwIDEgMSAwIDEuNTAxQS43NS43NSAwIDAgMSA4IDkuNW0uMDgtNC40OTZhLjczLjczIDAgMCAxIC42NDguNzg3bC0uMjMgMi43NWEuNTAxLjUwMSAwIDAgMS0uOTk2IDBsLS4yMy0yLjc1MUEuNzMuNzMgMCAwIDEgOCA1eiIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=3747-32415
*/
const Icon16Attention = memo(function Icon16Attention(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "16",
		height: "16",
		fill: "none",
		viewBox: "0 0 16 16",
		...props,
		"data-fpl-icon-size": "16",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2m0 1a5 5 0 1 0 0 10A5 5 0 0 0 8 3m0 6.5a.75.75 0 1 1 0 1.501A.75.75 0 0 1 8 9.5m.08-4.496a.73.73 0 0 1 .648.787l-.23 2.75a.501.501 0 0 1-.996 0l-.23-2.751A.73.73 0 0 1 8 5z"
		})
	});
});
//#endregion
export { Icon16Attention };

//# sourceMappingURL=icon-16-attention.js.map